import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import CustomizedButton from "./buttons/CustomizedButton";
import { history } from "../_helpers";
import { landingDomain } from "../_constants";

const CHINA_MODE_APPROVED_KEY = "china_mode_approved";
const CHINA_MODE_APPROVED_AT_KEY = "china_mode_approved_at";

// Текст ПК/ПС живёт только на лендинге (/var/www/html/agreements на китайском хосте),
// копии в репозитории нет: обновили документ на сервере — окно показывает новый.
// Грузим fetch'ем, а не iframe: обёртка приложения уводит любой чужой домен в системный
// браузер, на iOS — и загрузку внутри iframe. CORS для /agreements/ открыт в nginx
// лендинга (naviconf-docker, nginx-sites-default.conf).
const AGREEMENTS_URL = `https://${landingDomain}/agreements/`;
const AGREEMENTS_TIMEOUT_MS = 10000;

class ChinaModeGate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      approved: this.isApproved(),
      docHtml: null,
      docFailed: false,
    };
  }

  componentDidMount() {
    if (!this.state.approved) this.loadAgreements();
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  loadAgreements = () => {
    const controller = window.AbortController ? new AbortController() : null;
    const timer = setTimeout(() => controller && controller.abort(), AGREEMENTS_TIMEOUT_MS);
    fetch(AGREEMENTS_URL, controller ? { signal: controller.signal } : {})
      .then((response) => {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const sections = Array.from(doc.querySelectorAll("section"));
        if (!sections.length) throw new Error("no sections");
        sections.forEach((section) => {
          section.querySelectorAll("script, style, iframe").forEach((el) => el.remove());
          section.querySelectorAll("a[href]").forEach((a) => {
            a.setAttribute("target", "_blank");
            a.setAttribute("rel", "noopener");
          });
        });
        if (!this.unmounted)
          this.setState({ docHtml: sections.map((s) => s.outerHTML).join("") });
      })
      .catch(() => {
        // Нет сети или документа — остаётся прежнее окно со ссылкой.
        if (!this.unmounted) this.setState({ docFailed: true });
      })
      .finally(() => clearTimeout(timer));
  };

  isApproved = () => {
    if (process.env.REACT_APP_CHINA_MODE !== "true") {
      return true;
    }
    return localStorage.getItem(CHINA_MODE_APPROVED_KEY) === "true";
  };

  handleApprove = () => {
    localStorage.setItem(CHINA_MODE_APPROVED_KEY, "true");
    localStorage.setItem(
      CHINA_MODE_APPROVED_AT_KEY,
      new Date().toISOString()
    );
    this.setState({ approved: true });
    
    // Get redirect path from localStorage or default to home
    const redirectPath = localStorage.getItem("navic_redirect") || "/";
    history.push(redirectPath);
  };

  handleReject = () => {
    window.location.href = '/exit';
  };

  renderTitle() {
    return (
      <>
        请阅读并同意
        <a href={AGREEMENTS_URL} target="_blank" rel="noopener noreferrer" className="china-mode-link">
          《用户协议》和《隐私政策》
        </a>
      </>
    );
  }

  // Цвет кнопок — через CSS вокруг: `style` у CustomizedButton не доходит до кнопки,
  // а править общий компонент нельзя — тот же проп игнорируется на входе и регистрации,
  // и включение сдвинуло бы там вёрстку.
  renderButtons() {
    return (
      <>
        <span className="china-gate__btn china-gate__btn--accept">
          <CustomizedButton onClick={this.handleApprove} title="同意并继续" />
        </span>
        <span className="china-gate__btn china-gate__btn--reject">
          <CustomizedButton onClick={this.handleReject} title="拒绝退出" />
        </span>
      </>
    );
  }

  render() {
    // If China Mode is not enabled, render children
    if (process.env.REACT_APP_CHINA_MODE !== "true") {
      return this.props.children;
    }

    // If already approved, render children
    if (this.state.approved) {
      return this.props.children;
    }

    const { docHtml, docFailed } = this.state;

    // Полный текст на весь экран: заголовок и кнопки на месте, текст прокручивается
    if (!docFailed) {
      return (
        <Route
          render={() => (
            <div className="china-gate">
              <h3 className="china-gate__title">{this.renderTitle()}</h3>
              <div className="china-gate__doc">
                {docHtml ? (
                  <div dangerouslySetInnerHTML={{ __html: docHtml }} />
                ) : (
                  <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
                    <CircularProgress />
                  </div>
                )}
              </div>
              <div className="china-gate__actions">{this.renderButtons()}</div>
            </div>
          )}
        />
      );
    }

    // Show approval screen
    return (
      <Route
        render={() => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "100vh",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "40px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                textAlign: "center",
                maxWidth: "500px",
                width: "100%",
              }}
            >
               <h3 style={{ marginBottom: "30px" }}>{this.renderTitle()}</h3>
               <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
                 {this.renderButtons()}
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  return { authentication };
}

export default connect(mapStateToProps)(ChinaModeGate);
